// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OCF5h","colBig":"styles_colBig__1vask","colSmall":"styles_colSmall__1kAnE"};